import React, {useContext, useEffect} from 'react'
import {Typography, IconButton} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import './SelectedItems.scss'
import {ReservationContext} from '../../context/Reservation/Reservation'
import moment from 'moment'
import {useState} from 'react'

const SelectedItems = ({items, onRemove}) => {
  const {reservation, loadConfiguration, checkEntityObjects, checkObjects} = useContext(
    ReservationContext
  )
  const {selected_group, reserved_for, reserve_for_field, date_from, date_to} = reservation
  useEffect(() => {
    if (selected_group !== null && items?.length) {
      let ids = items.map(i => {
        return i.id
      })
      checkEntityObjects(selected_group?.id, {
        page: 1,
        limit: 50,
        start_date: moment(date_from)
          .local()
          .format(),
        end_date: moment(date_to)
          .local()
          .format(),
        object_ids: ids,
        reservation_uid: reservation.reservation_uid,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date_from, date_to, loadConfiguration, checkEntityObjects, selected_group])

  const getClassName = id => {
    let className = false
    if (checkObjects.data.entity_objects) {
      checkObjects.data.entity_objects.map(c => {
        if (c.id === id && c.label === 'disabled') {
          className = true
        }
        return true
      })
    }
    return className
  }
  return (
    <div className="c-selected-reserve-item ">
      <div className="c-selected-reserve-item__title">
        <Typography className="ap-typography ap-typography--sm">Selected Items</Typography>
      </div>
      <div className="c-selected-reserve-item__list ap-scrollbar">
        {items?.map(d => {
          return (
            <div
              className={`${
                getClassName(d.id) ? 'c-selected-reserve-item__disabled' : ''
              } c-selected-reserve-item__item`}
            >
              <span
                style={getClassName(d.id) ? {color: '#c91e03'} : {color: '#3473ff'}}
                className="ap-typography ap-typography--xxs ap-ellipsis"
              >
                {d.label}
              </span>
              <IconButton
                style={{
                  transform: 'scale(.75)',
                  color: `${getClassName(d.id) ? '#c91e03' : '#3473ff'}`,
                }}
                size="small"
                onClick={e => onRemove(e, d)}
              >
                <CloseIcon />
              </IconButton>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SelectedItems
